import { useClientState } from './state';
import { useCart } from './cart';
import { useAuthenticationState } from '../authentication/state';

export const useCartWatch = defineStore('repo.cart.watch', () => {
    const { monetary } = useClientState();

    const {
        $i18n
    }: any = useNuxtApp();

    // STORE TO REFS
    const {
        settings
    } = storeToRefs(useClientState());
    const {
        cart
    } = storeToRefs(useCart());

    const {
        authenticated
    } = storeToRefs(useAuthenticationState());

    const {
        cartManager
    } = useCart();

    const {
        currency
    } = toRefs(monetary);

    const {
        data,
        error,
        status,
        execute,
        refresh
    } = useFetch(() => `/api/${$i18n.locale.value}/cart/${settings.value?.country.toLowerCase()}/check`, {
        method: 'POST',
        headers: {
            Accept: "application/json",
            'Cache-Control': "no-cache",
            'X-Requested-With': 'pipeline-client-2'
        },
        body: computed(() => ({
            culture: cartManager.culture,
            items: cartManager.items
        })),
        immediate: false,
        watch: false,
    });

    const statusTimeout = ref(null);

    watch(status, async (s: string) => {
        clearTimeout(statusTimeout.value);

        if (s === 'pending') {
            statusTimeout.value = setTimeout(() => {
                cartManager.loading = true;
            }, 200);
        } else {
            cartManager.loading = false;
        }
    });
    
    watch([
        () => cart.value.statistics.sum,
        currency,
        authenticated,
        () => $i18n.locale.value
    ], async () => {
        console.log('[Cart-Watch]: Check.');
        await execute();

        await callOnce(async () => {
            await useTranslation('$pipeline.app.general.cart');
        });

        if (data.value) {
            cartManager.validations(data.value);
        }
    }, { immediate: true });

    return {

    };
});